import { useState } from "react";

import { PrimaryButton } from "@shared/buttons";

import { AdvancedSearchEditor } from "../advanced-search-editor";

interface Props {
  value: any;
  onChange(value: any): void;
  onSwitchToSimpleSearch(): void;
}

export const AdvancedSearchBox = ({
  value,
  onChange,
  onSwitchToSimpleSearch,
}: Props) => {
  const [localValue, setLocalValue] = useState<any>(value);

  return (
    <div className="border rounded-lg px-4">
      <AdvancedSearchEditor
        labelClassName="font-normal text-xs -mt-1"
        value={localValue}
        onChange={(val) => setLocalValue(val)}
        onSwitchToSimpleSearch={onSwitchToSimpleSearch}
      />
      <div className="py-3 flex justify-end">
        <PrimaryButton
          className="font-bold"
          onClick={() => onChange(localValue)}
        >
          SEARCH
        </PrimaryButton>
      </div>
    </div>
  );
};
